"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var quadkeytools = require('quadkeytools');
exports.locationToQuadkey = quadkeytools.locationToQuadkey;
exports.origin = quadkeytools.origin;
exports.bbox = quadkeytools.bbox;
function quadkeyCoordinates(quadkey) {
    var _a = exports.bbox(quadkey), min = _a.min, max = _a.max;
    return [
        [min.lng, max.lat],
        [max.lng, max.lat],
        [max.lng, min.lat],
        [min.lng, min.lat],
        [min.lng, max.lat],
    ];
}
exports.quadkeyCoordinates = quadkeyCoordinates;
function quadkeyType(feature) {
    var _a = exports.origin(feature.quadkey), latitude = _a.lat, longitude = _a.lng;
    return {
        type: 'Feature',
        properties: __assign({ latitude: latitude,
            longitude: longitude }, feature),
        geometry: {
            type: 'Polygon',
            coordinates: [quadkeyCoordinates(feature.quadkey)],
        },
    };
}
exports.quadkeyType = quadkeyType;
//# sourceMappingURL=quadkey.js.map